import CustomizeDataEditor from "./CustomizeDataEditor";
import CustomizeDataEditorProperty from "./CustomizeDataEditorProperty";
import CustomizeDataEditorPropertyLabel from "./CustomizeDataEditorPropertyLabel";
import CustomizeDataEditorPropertyValue from "./CustomizeDataEditorPropertyValue";

export default CustomizeDataEditor;
export {
  CustomizeDataEditor,
  CustomizeDataEditorProperty,
  CustomizeDataEditorPropertyLabel,
  CustomizeDataEditorPropertyValue,
};
